<template>
  <v-form class='viewMachineForm' v-model='valid' ref='viewMachineForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Machine : </label>
          <p>{{ machine.serial_no? machine.serial_no: '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Machine Serial No : </label>
          <p>{{ machine.machine_serial_no? machine.machine_serial_no: '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Purchase Date : </label>
          <p v-if="machine.purchase_date">{{ machine.purchase_date | formatDate }}</p>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Installation Date : </label>
          <p v-if="machine.installation_date">{{ machine.installation_date | formatDate }}</p>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Warranty Expiry Date : </label>
          <p v-if="machine.warranty_exp_date">{{ machine.warranty_exp_date | formatDate }}</p>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Machine Type : </label>
          <p>{{ machine.machine_type_name ? machine.machine_type_name : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Brand : </label>
          <p>{{ machine.brand ? machine.brand : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Model : </label>
          <p>{{ machine.model ? machine.model : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Amperage 60 Duty : </label>
          <p>{{ machine.amperage_60_duty ? machine.amperage_60_duty : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Amperage 100 Duty : </label>
          <p>{{ machine.amperage_100_duty ? machine.amperage_100_duty : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Remarks : </label>
          <p>{{ machine.remarks ? machine.remarks : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Status : </label>
          <p>
            <template>
              <v-chip :color="this.machine.status == 0 ? 'success' : 'warning'" small>{{ this.machine.status == 0 ? 'Active' : 'Inactive' }}</v-chip>
            </template>
          </p>
        </v-col>
      </v-row>
      <v-footer fixed v-if="$checkRight(['edit_machine'])">
        <v-col class="text-right">
          <v-btn color="primary" class="mr-2" @click="edit" small>Edit</v-btn>
        </v-col>
      </v-footer>
    </v-container>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.$axios.post('getMachineById/' + id).then((res) => {
        this.machine = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      machine: {},
      error: {}
    }
  },
  methods: {
    edit () {
      const editId = this.$route.params.id
      this.$router.push({ path: `/machine/edit/${editId}`, })
    }
  }
}
</script>

<style>
.viewMachineForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.viewMachineForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.viewMachineForm .view_label {
  font-size: 15px;
  font-weight: bold;
}
</style>
